/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FundFamilyInvestmentStatsData
} from '../../model/fundFamilyInvestmentStatsData'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  InvestmentEntityCreateEditAPIDataRequest
} from '../../model/investmentEntityCreateEditAPIDataRequest'
import type {
  InvestmentEntityReadAPIData
} from '../../model/investmentEntityReadAPIData'
import type {
  InvestmentEntityReadDataList
} from '../../model/investmentEntityReadDataList'
import type {
  InvestmentListParams
} from '../../model/investmentListParams'
import type {
  InvestmentTableDataRetrieveParams
} from '../../model/investmentTableDataRetrieveParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * List investments for a fund family
 */
export const investmentList = (
    fundFamilyId: string,
    params?: InvestmentListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestmentEntityReadDataList>(
      {url: `/fund-family/${fundFamilyId}/investment/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInvestmentListQueryKey = (fundFamilyId: string,
    params?: InvestmentListParams,) => {
    return [`/fund-family/${fundFamilyId}/investment/`, ...(params ? [params]: [])] as const;
    }

    
export const getInvestmentListQueryOptions = <TData = Awaited<ReturnType<typeof investmentList>>, TError = unknown>(fundFamilyId: string,
    params?: InvestmentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentList>>> = ({ signal }) => investmentList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentListQueryResult = NonNullable<Awaited<ReturnType<typeof investmentList>>>
export type InvestmentListQueryError = unknown

export const useInvestmentList = <TData = Awaited<ReturnType<typeof investmentList>>, TError = unknown>(
 fundFamilyId: string,
    params?: InvestmentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentList>>, TError = unknown>(fundFamilyId: string,
    params?: InvestmentListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentList>>> = ({ signal }) => investmentList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentList>>>
export type InvestmentListSuspenseQueryError = unknown

export const useInvestmentListSuspense = <TData = Awaited<ReturnType<typeof investmentList>>, TError = unknown>(
 fundFamilyId: string,
    params?: InvestmentListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentListLoader = (queryParamsOrFn?: (InvestmentListParams | ((params: Params) => InvestmentListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentListQueryKey(fundFamilyId, queryParams),
              queryFn: () => investmentList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a fund family investment
 */
export const investmentCreate = (
    fundFamilyId: string,
    investmentEntityCreateEditAPIDataRequest: InvestmentEntityCreateEditAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestmentEntityReadAPIData>(
      {url: `/fund-family/${fundFamilyId}/investment/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: investmentEntityCreateEditAPIDataRequest
    },
      options);
    }
  


export const getInvestmentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentCreate>>, TError,{fundFamilyId: string;data: InvestmentEntityCreateEditAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investmentCreate>>, TError,{fundFamilyId: string;data: InvestmentEntityCreateEditAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investmentCreate>>, {fundFamilyId: string;data: InvestmentEntityCreateEditAPIDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  investmentCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestmentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof investmentCreate>>>
    export type InvestmentCreateMutationBody = InvestmentEntityCreateEditAPIDataRequest
    export type InvestmentCreateMutationError = unknown

    export const useInvestmentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentCreate>>, TError,{fundFamilyId: string;data: InvestmentEntityCreateEditAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestmentCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific investment
 */
export const investmentRetrieve = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InvestmentEntityReadAPIData>(
      {url: `/fund-family/${fundFamilyId}/investment/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestmentRetrieveQueryKey = (fundFamilyId: string,
    id: string,) => {
    return [`/fund-family/${fundFamilyId}/investment/${id}/`] as const;
    }

    
export const getInvestmentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentRetrieve>>> = ({ signal }) => investmentRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investmentRetrieve>>>
export type InvestmentRetrieveQueryError = unknown

export const useInvestmentRetrieve = <TData = Awaited<ReturnType<typeof investmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentRetrieveQueryOptions(fundFamilyId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentRetrieve>>> = ({ signal }) => investmentRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentRetrieve>>>
export type InvestmentRetrieveSuspenseQueryError = unknown

export const useInvestmentRetrieveSuspense = <TData = Awaited<ReturnType<typeof investmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentRetrieveSuspenseQueryOptions(fundFamilyId,id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && id) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentRetrieveQueryKey(fundFamilyId,id),
              queryFn: () => investmentRetrieve(fundFamilyId,id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edit a specific investment
 */
export const investmentUpdate = (
    fundFamilyId: string,
    id: string,
    investmentEntityCreateEditAPIDataRequest: InvestmentEntityCreateEditAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<InvestmentEntityReadAPIData>(
      {url: `/fund-family/${fundFamilyId}/investment/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: investmentEntityCreateEditAPIDataRequest
    },
      options);
    }
  


export const getInvestmentUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentUpdate>>, TError,{fundFamilyId: string;id: string;data: InvestmentEntityCreateEditAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investmentUpdate>>, TError,{fundFamilyId: string;id: string;data: InvestmentEntityCreateEditAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investmentUpdate>>, {fundFamilyId: string;id: string;data: InvestmentEntityCreateEditAPIDataRequest}> = (props) => {
          const {fundFamilyId,id,data} = props ?? {};

          return  investmentUpdate(fundFamilyId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestmentUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof investmentUpdate>>>
    export type InvestmentUpdateMutationBody = InvestmentEntityCreateEditAPIDataRequest
    export type InvestmentUpdateMutationError = unknown

    export const useInvestmentUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentUpdate>>, TError,{fundFamilyId: string;id: string;data: InvestmentEntityCreateEditAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestmentUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a specific investment
 */
export const investmentDestroy = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/investment/${id}/`, method: 'DELETE'
    },
      options);
    }
  


export const getInvestmentDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentDestroy>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investmentDestroy>>, TError,{fundFamilyId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investmentDestroy>>, {fundFamilyId: string;id: string}> = (props) => {
          const {fundFamilyId,id} = props ?? {};

          return  investmentDestroy(fundFamilyId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestmentDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof investmentDestroy>>>
    
    export type InvestmentDestroyMutationError = unknown

    export const useInvestmentDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentDestroy>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestmentDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets summary stats for the investment entities in a fund family
 */
export const investmentEntityStatsRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyInvestmentStatsData>(
      {url: `/fund-family/${fundFamilyId}/investment/stats/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestmentEntityStatsRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/investment/stats/`] as const;
    }

    
export const getInvestmentEntityStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentEntityStatsRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>> = ({ signal }) => investmentEntityStatsRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentEntityStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>>
export type InvestmentEntityStatsRetrieveQueryError = unknown

export const useInvestmentEntityStatsRetrieve = <TData = Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentEntityStatsRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentEntityStatsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentEntityStatsRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>> = ({ signal }) => investmentEntityStatsRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentEntityStatsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>>
export type InvestmentEntityStatsRetrieveSuspenseQueryError = unknown

export const useInvestmentEntityStatsRetrieveSuspense = <TData = Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentEntityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentEntityStatsRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentEntityStatsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentEntityStatsRetrieveQueryKey(fundFamilyId),
              queryFn: () => investmentEntityStatsRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get investment table data for a fund family
 */
export const investmentTableDataRetrieve = (
    fundFamilyId: string,
    params?: InvestmentTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/investment/table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getInvestmentTableDataRetrieveQueryKey = (fundFamilyId: string,
    params?: InvestmentTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/investment/table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getInvestmentTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: InvestmentTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentTableDataRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentTableDataRetrieve>>> = ({ signal }) => investmentTableDataRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investmentTableDataRetrieve>>>
export type InvestmentTableDataRetrieveQueryError = unknown

export const useInvestmentTableDataRetrieve = <TData = Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: InvestmentTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentTableDataRetrieveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: InvestmentTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentTableDataRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentTableDataRetrieve>>> = ({ signal }) => investmentTableDataRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentTableDataRetrieve>>>
export type InvestmentTableDataRetrieveSuspenseQueryError = unknown

export const useInvestmentTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: InvestmentTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentTableDataRetrieveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentTableDataRetrieveLoader = (queryParamsOrFn?: (InvestmentTableDataRetrieveParams | ((params: Params) => InvestmentTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentTableDataRetrieveQueryKey(fundFamilyId, queryParams),
              queryFn: () => investmentTableDataRetrieve(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      